import { combineReducers, Reducer } from 'redux';

import workItemsSearch from './waivers/workItemsSearch';
import workItem from './waivers/workItem';

import { ComponentState, Action } from '../types';

const rootReducer: Reducer<ComponentState['waivers'], Action<any>> = combineReducers({
  workItemsSearch,
  workItem,
});

export default rootReducer;
